import React, { useEffect } from 'react';
import './styles/base.css';

export default function Index() {
  useEffect(() => {
    import('./error-handler.js');
    import('./ui.js');
  }, []);

  return (
    <div id="noVNC_wrapper">
      <div id="noVNC_fallback_error" className="noVNC_center">
        <div>
          <div>noVNC encountered an error:</div>
          <br />
          <div id="noVNC_fallback_errormsg"></div>
        </div>
      </div>
      <div id="noVNC_control_bar_anchor" className="noVNC_vcenter">
        <div id="noVNC_control_bar">
          <div id="noVNC_control_bar_handle" title="Hide/Show the control bar">
            <div></div>
          </div>

          <div className="noVNC_scroll">
            <h1 className="noVNC_logo" translate="no">
              <span>no</span>
              <br />
              VNC
            </h1>

            <input
              type="image"
              alt="Drag"
              src="/images/drag.svg"
              id="noVNC_view_drag_button"
              className="noVNC_button noVNC_hidden"
              title="Move/Drag Viewport"
            />

            <div id="noVNC_mobile_buttons">
              <input
                type="image"
                alt="No mousebutton"
                src="/images/mouse_none.svg"
                id="noVNC_mouse_button0"
                className="noVNC_button"
                title="Active Mouse Button"
              />
              <input
                type="image"
                alt="Left mousebutton"
                src="/images/mouse_left.svg"
                id="noVNC_mouse_button1"
                className="noVNC_button"
                title="Active Mouse Button"
              />
              <input
                type="image"
                alt="Middle mousebutton"
                src="/images/mouse_middle.svg"
                id="noVNC_mouse_button2"
                className="noVNC_button"
                title="Active Mouse Button"
              />
              <input
                type="image"
                alt="Right mousebutton"
                src="/images/mouse_right.svg"
                id="noVNC_mouse_button4"
                className="noVNC_button"
                title="Active Mouse Button"
              />
              <input
                type="image"
                alt="Keyboard"
                src="/images/keyboard.svg"
                id="noVNC_keyboard_button"
                className="noVNC_button"
                title="Show Keyboard"
              />
            </div>

            <div id="noVNC_extra_keys">
              <input
                type="image"
                alt="Extra keys"
                src="/images/toggleextrakeys.svg"
                id="noVNC_toggle_extra_keys_button"
                className="noVNC_button"
                title="Show Extra Keys"
              />
              <div className="noVNC_vcenter">
                <div id="noVNC_modifiers" className="noVNC_panel">
                  <input
                    type="image"
                    alt="Ctrl"
                    src="/images/ctrl.svg"
                    id="noVNC_toggle_ctrl_button"
                    className="noVNC_button"
                    title="Toggle Ctrl"
                  />
                  <input
                    type="image"
                    alt="Alt"
                    src="/images/alt.svg"
                    id="noVNC_toggle_alt_button"
                    className="noVNC_button"
                    title="Toggle Alt"
                  />
                  <input
                    type="image"
                    alt="Windows"
                    src="/images/windows.svg"
                    id="noVNC_toggle_windows_button"
                    className="noVNC_button"
                    title="Toggle Windows"
                  />
                  <input
                    type="image"
                    alt="Tab"
                    src="/images/tab.svg"
                    id="noVNC_send_tab_button"
                    className="noVNC_button"
                    title="Send Tab"
                  />
                  <input
                    type="image"
                    alt="Esc"
                    src="/images/esc.svg"
                    id="noVNC_send_esc_button"
                    className="noVNC_button"
                    title="Send Escape"
                  />
                  <input
                    type="image"
                    alt="Ctrl+Alt+Del"
                    src="/images/ctrlaltdel.svg"
                    id="noVNC_send_ctrl_alt_del_button"
                    className="noVNC_button"
                    title="Send Ctrl-Alt-Del"
                  />
                </div>
              </div>
            </div>

            <input
              type="image"
              alt="Shutdown/Reboot"
              src="/images/power.svg"
              id="noVNC_power_button"
              className="noVNC_button"
              title="Shutdown/Reboot..."
            />
            <div className="noVNC_vcenter">
              <div id="noVNC_power" className="noVNC_panel">
                <div className="noVNC_heading">
                  <img alt="" src="/images/power.svg" /> Power
                </div>
                <input type="button" id="noVNC_shutdown_button" value="Shutdown" />
                <input type="button" id="noVNC_reboot_button" value="Reboot" />
                <input type="button" id="noVNC_reset_button" value="Reset" />
              </div>
            </div>

            {/* <input type="image" alt="Clipboard" src='/images/clipboard.svg' id="noVNC_clipboard_button" className="noVNC_button" title="Clipboard" />
            <div className="noVNC_vcenter">
              <div id="noVNC_clipboard" className="noVNC_panel">
                <div className="noVNC_heading">
                  <img alt="" src="/images/clipboard.svg" /> Clipboard
                </div>
                <textarea id="noVNC_clipboard_text" rows={5}></textarea>
                <br />
                <input id="noVNC_clipboard_clear_button" type="button" value="Clear" className="noVNC_submit" />
              </div>
            </div> */}

            <input
              type="image"
              alt="Fullscreen"
              src="/images/fullscreen.svg"
              id="noVNC_fullscreen_button"
              className="noVNC_button noVNC_hidden"
              title="Fullscreen"
            />

            <input
              type="image"
              alt="Settings"
              src="/images/settings.svg"
              id="noVNC_settings_button"
              className="noVNC_button"
              title="Settings"
            />
            <div className="noVNC_vcenter">
              <div id="noVNC_settings" className="noVNC_panel">
                <ul>
                  <li className="noVNC_heading">
                    <img alt="" src="/images/settings.svg" /> Settings
                  </li>
                  <li>
                    <label>
                      <input id="noVNC_setting_shared" type="checkbox" /> Shared Mode
                    </label>
                  </li>
                  <li>
                    <label>
                      <input id="noVNC_setting_view_only" type="checkbox" /> View Only
                    </label>
                  </li>
                  <li>
                    <hr />
                  </li>
                  <li>
                    <label>
                      <input id="noVNC_setting_view_clip" type="checkbox" /> Clip to Window
                    </label>
                  </li>
                  <li>
                    <label htmlFor={'noVNC_setting_resize'}>Scaling Mode:</label>
                    <select id="noVNC_setting_resize" name="vncResize">
                      <option value="off">None</option>
                      <option value="scale">Local Scaling</option>
                      <option value="remote">Remote Resizing</option>
                    </select>
                  </li>
                  <li>
                    <hr />
                  </li>
                  <li>
                    <div className="noVNC_expander">Advanced</div>
                    <div>
                      <ul>
                        <li>
                          <label htmlFor="noVNC_setting_repeaterID">Repeater ID:</label>
                          <input id="noVNC_setting_repeaterID" type="text" value="" />
                        </li>
                        <li>
                          <div className="noVNC_expander">WebSocket</div>
                          <div>
                            <ul>
                              <li>
                                <label>
                                  <input id="noVNC_setting_encrypt" type="checkbox" />
                                  Encrypt
                                </label>
                              </li>
                              <li>
                                <label htmlFor="noVNC_setting_host">Host:</label>
                                <input id="noVNC_setting_host" />
                              </li>
                              <li>
                                <label htmlFor="noVNC_setting_port">Port:</label>
                                <input id="noVNC_setting_port" type="number" />
                              </li>
                              <li>
                                <label htmlFor="noVNC_setting_path">Path:</label>
                                <input id="noVNC_setting_path" type="text" value="websockify" />
                              </li>
                            </ul>
                          </div>
                        </li>
                        <li>
                          <hr />
                        </li>
                        <li>
                          <label>
                            <input id="noVNC_setting_reconnect" type="checkbox" />
                            Automatic Reconnect
                          </label>
                        </li>
                        <li>
                          <label htmlFor="noVNC_setting_reconnect_delay">
                            Reconnect Delay (ms):
                          </label>
                          <input id="noVNC_setting_reconnect_delay" type="number" />
                        </li>
                        <li>
                          <hr />
                        </li>
                        <li>
                          <label>
                            <input id="noVNC_setting_show_dot" type="checkbox" />
                            Show Dot when No Cursor
                          </label>
                        </li>
                        <li>
                          <hr />
                        </li>
                        <li>
                          <label>
                            Logging:
                            <select id="noVNC_setting_logging" name="vncLogging"></select>
                          </label>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li className="noVNC_version_separator">
                    <hr />
                  </li>
                  <li className="noVNC_version_wrapper">
                    <span>Version:</span>
                    <span className="noVNC_version"></span>
                  </li>
                </ul>
              </div>
            </div>

            <input
              type="image"
              alt="Disconnect"
              src="/images/disconnect.svg"
              id="noVNC_disconnect_button"
              className="noVNC_button"
              title="Disconnect"
            />
          </div>
        </div>

        <div id="noVNC_control_bar_hint"></div>
      </div>

      <div id="noVNC_status"></div>
      <div className="noVNC_center">
        <div id="noVNC_connect_dlg">
          <div className="noVNC_logo" translate="no">
            <span>no</span>VNC
          </div>
          <div id="noVNC_connect_button">
            <div>
              <img alt="" src="/images/connect.svg" /> Connect
            </div>
          </div>
        </div>
      </div>

      <div className="noVNC_center noVNC_connect_layer">
        <div id="noVNC_password_dlg" className="noVNC_panel">
          <form>
            <ul>
              <li>
                <label>Password:</label>
                <input id="noVNC_password_input" type="password" />
              </li>
              <li>
                <input
                  id="noVNC_password_button"
                  type="submit"
                  value="Send Password"
                  className="noVNC_submit"
                />
              </li>
            </ul>
          </form>
        </div>
      </div>

      <div id="noVNC_transition">
        <div id="noVNC_transition_text"></div>
        <div>
          <input
            type="button"
            id="noVNC_cancel_reconnect_button"
            value="Cancel"
            className="noVNC_submit"
          />
        </div>
        <div className="noVNC_spinner"></div>
      </div>

      <div id="noVNC_container">
        <textarea
          id="noVNC_keyboardinput"
          autoCapitalize="off"
          autoComplete="off"
          spellCheck="false"
          tabIndex={-1}
        ></textarea>
      </div>
    </div>
  );
}
